import React from "react";
import { extractRelevantFieldsByNumber } from "./App";
import Vertex from "./shudan/Vertex"
import { evaluationColors } from "./App";

const MoveDetails = ({ currentMoveNumber, nextMoveEvaluation, nextMoveScore, scoreIsLoading, nextMovePass, gameLength, inVariation }) => {

  const evaluationComments = {
          'blunder': 'Oops, that\'s a blunder!', 
          'mistake': 'That\'s a mistake.', 
          'inaccuracy': 'Not a good move.', 
          'good': 'Good move.', 
          'great': 'Great move!', 
          'optimal': 'An optimal move.', 
          'simplest': 'A simple optimal move.'
    }

  function roundToNearestHalf(num) {
    return Math.round(num * 2) / 2;
  }

  // Styling for the box
  const boxStyle = {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: "200px",
    height: "50px",
    borderRadius: "10px",
    fontSize: "14px",
    fontWeight: "bold",
    testAlign: "center",
    fontFamily: "monospace", // Prevent shifting by using monospaced font
    boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.2)", // Add some shading
    border: "1px solid rgba(0, 0, 0, 0.1)", // Subtle border for definition
    transition: "background-color 0.5s ease, color 0.5s ease" // shading transition 
    // background: {linear-gradient(180deg,#ccc 0,#eee 30%,#fff)}
  };

  // let displayScore = null
  // let displayNextMoveScore = null

  // // Get current score
  // if(analyzedMoves !== undefined && analyzedMoves.length >0) {

  //   const currentMoveData = extractRelevantFieldsByNumber(analyzedMoves, currentMoveNumber)
  //   const currentScore = roundToNearestHalf(currentMoveData?.score)

  //   const nextMoveData = extractRelevantFieldsByNumber(analyzedMoves, currentMoveNumber+1)
  //   const nextMoveScore = roundToNearestHalf(nextMoveData?.moveScore) 
  
  //   // Determine the background color and displayed score based on currentScore
  //   const isPositive = currentScore >= 0;
  //   displayScore = isPositive ? "B+" + String(currentScore) : "W+" + String(-currentScore); // Show absolute value for negative scores
  //   displayNextMoveScore = nextMoveScore !== undefined ? nextMoveScore : '' 
    
  //   boxStyle.backgroundColor = isPositive ? "black" : "white"
  //   boxStyle.color = isPositive ? "white" : "black"

  // } 

  const vertex = new Vertex({

      position: [null,null],
      sign: false, 
      marker: { 
        type: "number",
        moveNumber: currentMoveNumber ? currentMoveNumber : '',
        sign: 1, 
        playerColor: "W",
      },
      ghostStone: {
        sign: 1, 
        color: evaluationColors(1)[nextMoveEvaluation], 
      },

      moveScore: null, 
      // complexity: board.ghostStoneMap?.[y]?.[x]?.complexity, 
      // weight: board.ghostStoneMap?.[y]?.[x]?.weight, 

  })

  const textStyle = {
    display: "inline-block",
    lineHeight: "1", // Fix line height for proper vertical centering
    minWidth: "7ch", // Ensures consistent width for 5 characters, including minus and decimal
    textAlign: "left",
    fontSize: "14px",
    margin: "10px", 
    opacity: scoreIsLoading ? 0.25 : 1
  };

  const nextMoveStyle = {
    fontSize: "16px", 
    // flex: "1", 
    // display: "flex", 
    // justifyContent: "center",
    // alignItems: "center", 
    textAlign: "center",
    opacity: scoreIsLoading ? 0.25 : 1,
    margin: "0 auto",
    position: "relative",
  }

  const nextMoveNumber = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)", // Centers the text
    zIndex: 10000, // Ensure it's above the Vertex
    pointerEvents: "none", // Prevent pointer interaction
    fontWeight: "bold",
    fontSize: "0.8em", 
    color:
      vertex?.marker?.playerColor === "B" ? "white" : "black",
    textShadow: "0 0 0.5px rgba(0, 0, 0, 0.8)", // Add a shadow for better visibility
}

  // Set a fixed height so the div remains stable
  const containerStyle = {
    height: "80px", // Adjust as needed
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
  };

// console.debug(typeof nextMoveScore, nextMoveScore, nextMoveScore === 0)

  return (
    <div className="move-details panel" style={containerStyle}>
    <div style="display: flex; align-items: center; width: 100%;">
      {((currentMoveNumber < gameLength) || inVariation) && !isNaN(nextMoveScore) && <div style="position: relative; display: inline-block">
        <div style="width: 2em; height: 2em; margin: 5px; pointer-events: none; text-align: left;">{vertex}</div>
        <div style={nextMoveNumber}>{currentMoveNumber+1}</div>
      </div>}
      <span style="width: 100%; display: flex; align-items: center; text-align: center; position: relative;">
        {currentMoveNumber < gameLength && nextMovePass && <span style="left: 0; margin-left: 5px; position: absolute;">Pass.</span>}
        {currentMoveNumber === gameLength && !inVariation && <span style="left: 0; margin-left: 15px; position: absolute;">Game end.</span>}
        <span style={nextMoveStyle}>
          {((currentMoveNumber < gameLength) || inVariation) && !isNaN(nextMoveScore) ? nextMoveScore : ''}
        </span>
      </span>
    </div>
    <div style="width: 100%; margin-left:5px">
    {((currentMoveNumber < gameLength) || inVariation) && 
      <span style={textStyle}>{!!nextMoveEvaluation && evaluationComments[nextMoveEvaluation]}</span>}
    </div>
    </div>
  );
};

export default MoveDetails;
